<template>
    <DModal
        show="props.showModal"
        :title="__('customers.contracts.restore_contract.modal_title')"
        :message="__('customers.contracts.restore_contract.modal_message')"
        is-confirm
        is-error
        :is-awaiting-validation="true"
        @confirm="activateRestore"
        @close="emit('close-modal')"
    >
        <div style="padding: 15px">
            <DFormRow
                :label="__('customers.contracts.restore_contract.send_withdrawal_email_checkbox')"
                is-required
            >
                <DSwitch
                    id="send_withdrawal_email"
                    v-model="form.send_withdrawal_email"
                />
            </DFormRow>
        </div>
    </DModal>
</template>

<script setup>
import { useForm } from '@inertiajs/vue3'
import { ref } from 'vue'
import { route } from '~@/Composables/route'

const props = defineProps({
    contract: {
        type: Object,
        default: () => { return {} }
    },
    showModal: {
        type: Boolean,
        default: false
    },
    errorsData: {
        type: Object,
        default: () => { return {} }
    },
    redirectTo: {
        type: String,
        default: () => ''
    },
    filters: {
        type: Object,
        default: () => { return {} }
    }
})
const emit = defineEmits(['close-modal'])
const form = useForm({
    send_withdrawal_email: false,
    redirect_to: props.redirectTo,
    filters: props.filters
})
const errors = ref(props.errorsData)

const activateRestore = () => {
    form.post(route('customers.customers.contracts.restore-contract', {
        customer: props.contract.customer_id,
        contract: props.contract.id
    }), {
        onSuccess: () => {
            emit('close-modal')
        },
        onError: (error) => {
            errors.value = error
        }
    })
}
</script>
